<!-- eslint-disable max-len -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
    v-html="path" />
</template>
<!-- eslint-enable max-len -->

<script setup>
import { computed, watchEffect } from 'vue'
import { ICON_PATHS } from './paths'

// Local replacement for the (now dead) FontAwesome CDN kit. Kept deliberately
// small: only the glyphs actually used in the dashboard UI. Sized with
// width/height="1em" so the existing `text-*` utility classes at every call
// site keep controlling size (same trick FA's icon font relied on), and
// stroke="currentColor" so `text-gray-400` etc. keep controlling color.
//
// The path data lives in ./paths so prop validators in other components can
// check a name against the real set instead of duplicating the list.

const props = defineProps({ name: { type: String, required: true } })

const path = computed(() => ICON_PATHS[props.name] || '')

// An unknown name renders an empty (but valid, non-crashing) <svg> rather
// than a broken box — silently missing an icon is a much smaller UI defect
// than throwing and taking the surrounding component down with it. Warn in
// dev only, so a typo is caught during development without spamming prod.
if (import.meta.env.DEV) {
  watchEffect(() => {
    if (!(props.name in ICON_PATHS)) {
      // eslint-disable-next-line no-console
      console.warn(`UiIcon: unknown icon name "${props.name}"`)
    }
  })
}
</script>
